<template>
  <v-app class="pa-2" v-show="!progress">
    <!-- ふきだし -->
    <v-container v-if="showBubble">
      <OrderConfirmBubble v-if="order" :order="order" />
    </v-container>

    <!-- メニュー一覧 -->
    <v-container v-if="showMenuContents && order">
      <OrderDetail :mode="1" :order="order" :showReOrder="false" />
    </v-container>

    <v-container v-if="showButtonArea">
      <v-row>
        <v-col>
          <v-btn x-large block tile text outlined @click="changeCart"
            >注文を修正する</v-btn
          >
        </v-col>
      </v-row>
      <v-row class="">
        <v-col align="center" class="pt-2">
          <v-btn
            v-if="wayOfPay === '0'"
            x-large
            block
            tile
            color="#ff7043"
            class="white--text text-button"
            @click="nextBefore"
          >
            決済へすすむ
          </v-btn>
          <v-btn
            v-else
            x-large
            block
            tile
            color="#ff7043"
            class="white--text text-button"
            @click="showConfirm"
          >
            予約する
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- sheet (最終確認) -->
    <v-bottom-sheet v-model="showConfirmSheet" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                question=""
                content="予約を確定してよろしいですか？"
                :border-content="false"
              />
            </v-col>
          </v-row>

          <div class="mt-8 mb-4">
            <QuickReply text="キャンセル" class="ma-2" :click="closeConfirm" />
            <QuickReply text="確定する" bgColor="#ff7043" :click="nextAfter" />
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- sheet 共通(トーク画面へもどる) -->
    <v-bottom-sheet v-model="showCmnSheet" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                question=""
                :content="sheetCmnText"
                :border-content="false"
              />
            </v-col>
          </v-row>
          <div style="align: center; width: 100%">
            <v-btn x-large text @click="close"
              ><span class="text-decoration-underline white--text"
                >トーク画面へもどる</span
              ></v-btn
            >
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- sheet エラー(カート移動) -->
    <v-bottom-sheet v-model="showSheetCart" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble :content="errorSheetCartText" :border-content="false" />
            </v-col>
          </v-row>
          <div class="mt-8 mb-8">
            <QuickReply
              text="カートを表示する"
              class="ma-2"
              :click="onClickToCart"
            />
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </v-app>
</template>

<script>
import liff from "@line/liff";
import { mapGetters, mapActions } from "vuex";
import { closeWindow, getAccessToken } from "../util/liff_util";
import OrderConfirmBubble from "./parts/OrderConfirmBubble";
import OrderDetail from "./parts/OrderDetail";
import Bubble from "./parts/Bubble";
import QuickReply from "./parts/QuickReply";
import { CHECK_TYPE, createCheckErrMsg } from "../util/order_util";
import { MSG_TYPE } from "../components/error/errorConstants";

// エラーシート
const SHEET_ERR_CMN = 0;
const SHEET_ERR_CART = 1;

export default {
  name: "Order",
  components: {
    OrderConfirmBubble,
    OrderDetail,
    Bubble,
    QuickReply,
  },
  props: {},
  data: () => ({
    queryCartId: "",
    wayOfPay: "0", // 0:先払い 1:後払い

    // 表示制御
    showBubble: false,
    showMenuContents: false,
    showButtonArea: false,
    //
    showConfirmSheet: false,
    showCmnSheet: false,
    sheetCmnText: "",
    showSheetCart: false,
    errorSheetCartText: "",
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "最終確認";
  },
  async mounted() {
    await liff.ready; // LIFF 初期化待機
    this.showProgress();

    try {
      // カートID(クエリ)
      const queryCartId = this.$route.query.cartId;
      console.log("cartId(query)", queryCartId);
      if (!queryCartId) {
        // URL 直指定 (ありえない)
        throw new Error("implemented (cartId なし)");
      }
      this.queryCartId = queryCartId;

      // 先払い/後払い
      this.wayOfPay = this.$route.query.wayOfPay;

      await this.bindNotPassedProcess();
    } catch (e) {
      console.error(e);
      const msgType = MSG_TYPE.LOAD;
      this.$router.replace({ name: "Error", query: { msgType: msgType } });
    } finally {
      this.hideProgress();
    }
  },
  computed: {
    ...mapGetters(["local", "progress", "order"]),
  },
  watch: {
    order: function () {
      if (!this.order) {
        return;
      }
      // ページ内コンテンツ
      this.showBubble = true;
      this.showMenuContents = true;
      this.showButtonArea = true;
    },
  },
  methods: {
    ...mapActions([
      "showProgress",
      "hideProgress",
      "checkBeforeInitNotPassed",
      "fetchTempOrderData",
      "checkBeforeInit",
    ]),
    ...mapActions("rest", ["deleteCartMenusByMstChanged", "payAfter"]),

    bindNotPassedProcess: async function () {
      // 事前チェック
      const checkResult = await this.checkBeforeInitNotPassed({
        queryCartId: this.queryCartId,
      });
      if (!checkResult.result) {
        const checkType = checkResult.type;
        const msg = createCheckErrMsg(checkType);
        this.showSheetCart = true;
        this.errorSheetCartText = msg;
        return;
      }

      // 仮注文データ取得
      await this.fetchTempOrderData();
    },
    nextBefore: function () {
      // 先払い
      // 画面遷移 (決済方法選択)
      this.$router.push({
        name: "PaySelect",
        query: { cartId: this.queryCartId },
      });
    },
    showConfirm: function () {
      this.showConfirmSheet = true;
    },
    closeConfirm: function () {
      this.showConfirmSheet = false;
    },
    nextAfter: async function () {
      // シート(確認) 閉じる
      this.showConfirmSheet = false;

      this.showProgress();
      try {
        // 後払い
        const queryCartId = this.queryCartId;

        // liff token
        let liffAccessToken = getAccessToken();
        if (this.local) {
          liffAccessToken = "LIFF_ACCESS_TOKEN";
        }

        // 事前チェック
        const beforeCheckResult = await this.checkBeforeInit({ queryCartId });
        if (!beforeCheckResult.result) {
          const checkType = beforeCheckResult.type;
          const sheetType = this.getErrorSheetType(checkType);
          const msg = createCheckErrMsg(checkType);
          this.showErrorSheet(sheetType, msg);
          return;
        }

        // 予約
        await this.payAfter({ liffAccessToken });

        // シート
        const msg = "ご予約ありがとうございます。店頭でお待ちしております。";
        this.showSuccessSheet(msg);
      } catch (e) {
        console.error(e);
        // シート (システムエラー)
        const msg = "大変申し訳ございません。現在予約できません。";
        this.showErrorSheet(SHEET_ERR_CMN, msg);
      } finally {
        this.hideProgress();
      }
    },
    getErrorSheetType: function (checkType) {
      switch (checkType) {
        case CHECK_TYPE.MST_MENU_SOLDOUT:
        case CHECK_TYPE.MST_MENU_CHANGED:
        case CHECK_TYPE.MST_MENU_DELETED:
        case CHECK_TYPE.ORDER_AVAILABLE:
        case CHECK_TYPE.USER_VISIT_TIME:
          return SHEET_ERR_CART;
        default:
          return SHEET_ERR_CMN;
      }
    },
    showSuccessSheet: function (msg) {
      this.sheetCmnText = msg;
      this.showCmnSheet = !this.showCmnSheet;
    },
    showErrorSheet: function (type, msg) {
      switch (type) {
        case SHEET_ERR_CMN:
        default:
          this.sheetCmnText = msg;
          this.showCmnSheet = !this.showCmnSheet;
          break;
        case SHEET_ERR_CART:
          this.errorSheetCartText = msg;
          this.showSheetCart = !this.showSheetCart;
          break;
      }
    },
    changeCart: function () {
      // 画面遷移(カート)
      this.$router.push({ name: "Cart" });
    },
    onClickToCart: async function () {
      // カート内アイテム削除
      await this.deleteCartMenusByMstChanged();

      // 画面遷移 (カート)
      this.$router.push({ name: "Cart" });
    },
    close: function () {
      // LIFF 閉じる
      closeWindow();
    },
  },
};
</script>
